<template>
  <div>
    <h1>Oferta weselna</h1>
    <hr />
    <div id="ofertakat">
      <router-link :to="{name:'kategorieWodki'}">
        <img src="../assets/img/woda1.png" />
        <h3>Wódki</h3>
      </router-link>
      <router-link :to="{name:'kategorieWina'}">
        <img src="../assets/img/wina1.png" />
        <h3>Wina</h3>
      </router-link>
      <router-link :to="{name:'kategoriePrezenty'}">
        <img src="../assets/img/prezenty1.png" />
        <h3>Prezenty</h3>
      </router-link>
      <router-link :to="{name:'kategorieZestawy'}">
        <img src="../assets/img/zestaw1.png" />
        <h3>Zestawy</h3>
      </router-link>
      <router-link :to="{name:'kategorieInne'}">
        <img src="../assets/img/zestaw1.png" />
        <h3>Inne</h3>
      </router-link>
    </div>
    
    <section class="opisuslugi" style="clear:both;">
      <p>
        Aby zdjąć z Waszych ramion jak najwięcej stresów związanych z organizacją wesela, zebraliśmy całą ofertę win i alkoholi mocnych w jednym miejscu.
        Wszystko czego potrzebujecie – na wyciągnięcie ręki.
      </p>
      <p>Każda przyszła Para Młoda, która decyduje się na wesele staje przed ogromnym zadaniem logistycznym, jakim jest jego zaplanowanie. Już na samym początku pojawiają się dziesiątki pytań i na każde można odpowiedzieć na wiele różnych sposobów. Nawet jeśli uda nam się podejść do tematu na spokojnie i z ‘chłodną głową’ to organizacja tego wyjątkowego wieczoru może być wyjątkowo stresująca. I o ile wybór miejsca jest jednym z kluczowych decyzji, to sam w sobie nie jest skomplikowany. Prawdziwe wyzwanie to odpowiedzieć na pytanie, które może mieć wiele skrajnie różnych odpowiedzi. Do takich skrajnie rozbudowanych zadań należy właśnie wybór alkoholu na wesele. Dlaczego? Bo ma dziesiątki rozwiązań, które mogą być zarówno bardzo trafione jak albo mogą stać się rozczarowaniem dla Was i dla Waszych gości.</p>
      <p>Czy jednak wybór alkoholu, który pojawi się na Waszych weselnych stołach musi przyprawiać Was o ból głowy a liczenie butelek i pytanie ‘czy tyle na pewno wystarczy?’ musi śnić się Wam po nocach? Absolutnie nie. Wystarczy, że przy wyborze będzie się kierować kilkoma prostymi zasadami albo zaufacie specjalistom – czyli nam 😉 Ale o tym później. Przejdźmy do tego, czym się kierować, aby nie zwariować.</p>
      <h3>Zasada numer 1: POMYŚLCIE O TERMINIE</h3>

      <p>
        To, w jakim miesiącu planujecie swoje wesele ma ogromny wpływ na to, co pojawi się na Waszych stołach, jak będą ubrani goście i jak będą się czuć. Wybór alkoholu również można dostosować pod względem ‘sezonowości’. Ogólna zasada jest prosta: w sezonie wiosna- lato potrzebujemy więcej chłodnych napojów, często podawanych z lodówki lub coolera z lodem. Dania są lżejsze, na stołach królują sezonowe warzywa i owoce a goście ubrani są w jasne kolory. Co nam się nasuwa na samą myśl o letnim weselu? Białe wino, schłodzone bąbelki i oczywiście drinki! Goście czujący się lekko, orzeźwieni odpowiednimi napojami to klucz do udanej zabawy. A poza tym, nie ma nic gorszego niż jasna, letnia sukienka zalana przez przypadek czerwonym winem, prawda?
        Wesele jesienno- zimowe i selekcja alkoholi na nie jest z kolei odwrotnością. Na stołach pojawiają się gorące potrawy, często dużo cięższe niż latem. Często pojawiają się w nich korzenne przyprawy, mięsa i gęste, aromatyczne sosy. Idealną propozycją do takiego menu będą wina czerwone, które poprawiają trawienie pobudzając naszych gości do weselnych tańców i zabaw.
        Jak widzicie, już na samym początku planowania klaruje się nam powoli pewien ogólny zarys weselnej selekcji alkoholi. Mamy więc bazę. Co dalej?
      </p>
      <h3>Zasada numer 2: PRZYJRZYJCIE SIĘ SWOJEJ LIŚCIE GOŚCI</h3>
      <p>
        Sprawdźcie nie tylko ich liczbę, ale spójrzcie na nią bardziej analitycznym wzrokiem. Czy planujecie obecność dzieci? Czy na sali pojawią się osoby starsze lub w szczególnej kondycji zdrowotnej? A może będziecie gościć kobietę w ciąży? Przeważać będą mężczyźni czy może kobiety? Jaka będzie średnia wieku zebranych osób? A może będziecie gościć kogoś na restrykcyjnej diecie? Wszystkie te detale mogą Wam pomóc stworzyć idealną selekcję alkoholi a żaden z gości nie poczuje się pominięty. Dlaczego to ważne? Przy próbie wyliczenia zapotrzebowania na alkohol bierzemy pod uwagę liczbę gości, którą roboczo nazywamy ‘liczbą gości netto’, czyli ogólną ilość z listy pomniejszoną o dzieci i gości ewidentnie niepijących. Za to, chętnie zaproponujemy Wam wina bezalkoholowe dla kobiet w ciąży lub np. wina vegańskie, jeśli będzie taka potrzeba. I spokojnie, nasz
        <router-link :to="{name:'calculator'}">kalkulator</router-link>przypomni Wam o tych możliwościach w odpowiednim momencie, ale nie będzie naciskał na ich wybór.
      </p>
      <h3>Zasada numer 3: OKREŚLCIE UPODOBANIA</h3>

      <p>Najlepsza selekcja to ta, która bierze pod uwagę upodobania Wasze i Waszych gości. Zastanówcie się, czy Wasi goście tradycyjnie postawią na wódkę czy może będą woleli wina (pomocny w tym będzie punkt nr. dwa, bo możemy założyć na przykład, że jeśli na naszej liście znajduje się więcej mężczyzn to będziemy potrzebować więcej wódki. Fakt, to jest stereotyp, ale z doświadczenia wiemy, że sprawdza się w większości przypadków). Pomyślcie też co Wasi goście wybierają dla siebie w swoich domach. Nie decydujcie się na wina wytrawne tylko dlatego, że są bardziej ‘eleganckie’. Zwłaszcza, jeśli zdecydowana większość gości pija jedynie słodkie alkohole. Dzięki temu wszyscy poczujecie się swobodniej podczas weselnej zabawy. Oczywiście pamiętajcie o swoich upodobaniach! Jeśli chcecie podkreślić Wasze przywiązanie np. do Waszych romantycznych zaręczyn w słonecznej Italii – może warto pomyśleć o winach właśnie z tamtego regionu? A może, jeśli będziecie gościć dużo bliskich z zagranicy, warto zaproponować im rodzime, polskie wina jako ciekawostkę? Mamy mnóstwo możliwości, ale jeśli nie znacie upodobań lub jeśli są skrajnie różne, postawcie zdecydowanie na…</p>
      <h3>Zasada numer 4: UNIWERSALNOŚĆ</h3>

      <p>To świetnie, jeśli możecie dokładnie określić upodobania gości i wybrać dla nich selekcję alkoholi skrojoną ‘na miarę’. Z dumą patrzymy jak ‘winna’ świadomość rozwija się w naszym kraju i wielokrotnie tworzyliśmy już indywidualne oferty opierające się nie tylko na podziale win na białe i czerwone lub słodkie i wytrawne, ale z uwzględnieniem konkretnych szczepów, regionów, roczników a nawet konkretnych działek z wybranych winnic. Z doświadczenia jednak wiemy, że im bardziej szczegółowa selekcja tym możemy albo bardzo dobrze dobrać alkohol dla gości albo bardzo mocno się pomylić… Jeśli więc nie macie tak szczególnych wymagań postawcie na uniwersalność. Mamy w swojej ofercie wyjątkowo dużo propozycji, które bazują na bardzo dobrej jakości, ale mają pośredni charakter. Na czym to polega? Potrafimy wybrać wino, które jednocześnie będzie smakowało osobom, które się na nim znają i pijają jedynie wytrawne i gościom, którzy z winem mają kontakt sporadyczny i sięgają jedynie po propozycje typowo słodkie. Taka selekcja opiera się na naszej profesjonalnej wiedzy i znajomości naszych produktów. Wiemy, który kraj produkuje wina wytrawne, ale z takich szczepów, które naturalnie są bardzo słodkie i mimo braku dodatku cukru ta słodycz będzie wyczuwalna. Możecie więc nam zaufać i spokojnie zdać się na nas, albo samodzielnie wybrać wina delikatnie wytrawne lub półwytrawne, aby zadowolić zróżnicowaną grupę gości. Nasza rada? Zawsze wybierajcie wina o stopień wytrawniejsze od tych, które kupujecie na co dzień. Dzięki temu goście będą się czuć lżej i będą się zdecydowanie lepiej bawić.</p>
      <h3>Zasada numer 5: SKORZYSTAJ Z NASZEGO KALKULATORA</h3>

      <p>Poprzednie punkty pokazałby Wam tylko ile możliwości macie przed sobą? Nadal nie czujecie się pewnie? Skorzystajcie z naszego kalkulatora. To nie tylko zwykły algorytm obliczeniowy. Budowaliśmy go całą załogą mając na uwadze wszystkie pytania, które zadały nam przyszłe Młode Pary przez lata naszej działalności. Każde z nas dołożyło tam coś od siebie – swoją wiedzę i swoje obawy. Chcieliśmy, aby to, co zwykle jest tylko chłodną kalkulacją było intuicyjnym, prostym procesem bazującym na naszym doświadczeniu i Waszych emocjach. Na bieżąco możecie podejrzeć nasze porady, czy sprawdzić co mieliśmy na myśli dodając każdy kolejny krok i każdą rubryczkę do uzupełnienia. Zrobiliśmy wszystko by ostatecznym wynikiem nie była tylko liczba ale też garść sugestii, oraz gotowa selekcja alkoholi, gotowa do zamówienia jednym kliknięciem.</p>
      <p>Pamiętajcie, że te zasady mają Wam ułatwić wybór. Wyeliminować z morza możliwości wszystkie te, które nie pasują do Was, Waszego wesela i Waszych gości tak, aby na końcu zostały tylko propozycje najbardziej wartościowe. Jeśli jednak nadal nie jesteście pewni swoich wyborów i chcielibyście omówić też inne aspekty selekcji jak np. przewidywany budżet, czy określenie rodzajów alkoholu na kolejne punkty uroczystości od wejścia na salę do upominków dla wychodzących gości, pamiętajcie, że cały czas jesteśmy dla Was dostępni wszelkimi możliwymi kanałami. Nie bójcie się zadawać pytań! Im więcej odpowiedzi dostaniecie – tym bardziej precyzyjny będzie Wasz wybór. Dołożymy do tego wszelkich starań!</p>
      <p>
        Napiszcie do nas:
        <br />Na internetowym chacie online:
        <a href="https://www.dobrewino.pl">www.dobrewino.pl</a>
        <br />Wiadomość e-mail:
        <a href="mailto:wesele@dobrewino.pl">wesele@dobrewino.pl</a>
        <br />Na portalu Facebook:
        <a href="https://www.facebook.com/dobrewinopl">www.facebook.com/dobrewinopl</a>
        <br />Na Instagramie:
        <a href="https://www.instagram.com/dobrewino.pl">www.instagram.com/dobrewino.pl</a>
        <br />
        <br />Możecie też z nami porozmawiać:
        <br />Tel: 42 295 02 10
        <br />+48 695 140 015
        <br />
      </p>
    </section>
    <section id="oferta">
      <h2>Oferta weselna / dodatkowe usługi</h2>
      <hr />
      <router-link :to="{name:'cateringWinny'}">
        <img src="../assets/mainpikto/2.png" />
        <h3>Catering winny</h3>
        <hr />
      </router-link>
      <router-link :to="{name:'kategorieZestawy'}">
        <img src="../assets/mainpikto/3.png" />
        <h3>Zestawy weselne</h3>
        <hr />
      </router-link>
      <a href="#">
        <img src="../assets/mainpikto/4.png" />
        <h3>Zaprojektuj etykietę</h3>
        <hr />
      </a>
      <a href="#">
        <img src="../assets/mainpikto/5.png" />
        <h3>Zaprojektuj kartkę</h3>
        <hr />
        <span>więcej</span>
      </a>
      <a href="#">
        <img src="../assets/mainpikto/6.png" />
        <h3>Sklep dobrewino.pl</h3>
        <hr />

        <span>więcej</span>
      </a>
      <a href="#">
        <img src="../assets/mainpikto/7.png" />
        <h3>Prezenty na ślub</h3>
        <hr />
        <span>więcej</span>
      </a>
      <a href="#">
        <img src="../assets/mainpikto/8.png" />
        <h3>Upominki dla gości</h3>
        <hr />
        <span>więcej</span>
      </a>
      <router-link :to="{name:'alkoholNaWieczorPanienski'}">
        <img src="../assets/mainpikto/9.png" />
        <h3>Alkohol na wieczór panieński</h3>
        <hr />
        <span>więcej</span>
      </router-link>
      <a href="#">
        <img src="../assets/mainpikto/10.png" />
        <h3>kosze prezentowe dla rodziców</h3>
        <hr />
        <span>więcej</span>
      </a>
      <router-link :to="{name:'doradztwoWeselne'}">
        <img src="../assets/mainpikto/11.png" />
        <h3>Doradztwo weselne</h3>
        <hr />
        <span>więcej</span>
      </router-link>
      <router-link :to="{name:'alkoholNaWieczorKawalerski'}">
        <img src="../assets/mainpikto/12.png" />
        <h3>Alkohol na wieczór kawalerski</h3>
        <hr />
        <span>więcej</span>
      </router-link>
    </section>
    <foot></foot>
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";

export default {
  components: {
    foot: Footer,
  },
};
</script>
<style scoped>

.opisuslugi {max-width:980px;  margin:0 auto;}
.opisuslugi p {
  font-size: 18px;
}
.opisuslugi a {
  color: #b2172f;
  font-weight: bold;
}
</style>